import { createAsyncThunk } from "@reduxjs/toolkit";
import { orderErrorToast, orderSuccessToast } from "../../../app/funcs/orderResultToast";
import { InquiryStatus } from "../../../domain/inquiry/Inquiry";
import { InquiryId } from "../../../domain/inquiry/InquiryId";
import { getInquiryList, getInquiry, updateInquiry, registerInquiry } from "./api";

export const ActionType = Object.freeze({
    base: "@@Monitoring/Action/Inquiry",
    getInquiryList: "getInformationList",
    getInquiry: "getInquiry",
    updateInquiry: "updateInquiry",
    updateInquiryMemo: "updateInquiryMemo",
    registerInquiry: "registerInquiry"
});

export const getInquiryListAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getInquiryList}`,
    async (_, { rejectWithValue }) => {
        const response = await getInquiryList();

        if (response.error === undefined) {
            // API処理結果正常の場合
            return { ...response };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const getInquiryDetailAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getInquiry}`,
    async (params: { id: string }, { rejectWithValue }) => {
        const { id } = params;
        const response = await getInquiry(id);
        if (response.error === undefined) {
            return { ... response };
        } else {
            return rejectWithValue({});
        }
    }
);

export const updateInquiryAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.updateInquiry}`,
    async (params: { id: InquiryId, status?: InquiryStatus, memo?: string, successMessage: string }, { rejectWithValue }) => {
        const { id, status, memo, successMessage } = params;
        const response = await updateInquiry(id.value, status, memo);
        if (response.error === undefined) {
            orderSuccessToast(successMessage);
            return { ...response };
        } else {
            orderErrorToast("更新に失敗しました");
            return rejectWithValue({});
        }
    }
);

export const registerInquiryAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.registerInquiry}`,
    async (params: { careRecipientId: string | null, tel: string | null, category: string, content: string, email: string, successHandler: () => void }, { rejectWithValue }) => {
        const { careRecipientId, tel, category, content, email, successHandler } = params;
        const response = await registerInquiry(careRecipientId, tel, category, content, email);
        if (response.error === undefined) {
            successHandler();
            return { ...response };
        } else {
            orderErrorToast("問い合わせに失敗しました");
            return rejectWithValue({});
        }
    }
);